module.exports = __webpack_public_path__ + "static/media/UC Compound Landscape Cam 01.RGB_color.0000 (0-00-00-00)_1.68bce5c2.webp";